import Styled from 'styled-components'

export default Styled.div`

img {
    margin-top:85px;
    margin-bottom:25px;
}

`
